import { createContext as commonCreateContext } from "packages/react";

export const createContext = commonCreateContext;
